import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ConfirmationService } from '@services/sys/confirmation.service';
import { NzSelectComponent } from 'ng-zorro-antd/select';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-z-select',
  templateUrl: './z-select.component.html',
  styleUrl: './z-select.component.less'
})
export class ZSelectComponent implements OnChanges {
    @Input() submitLoading = false;
    @Input() isRestrained = false;
    @Input() required = false;
    @Input() options: string[] = [];
    @Input() initialValue!: string | string[];
    @Input() inactiveUsers: boolean = false;
    @Output() valueChange = new EventEmitter();
    @ViewChild('selectComponent') selectComponent!: NzSelectComponent;
    isEditing = false;
    openMenu = false;
    currentValue: any;
    lastValue: string[] | string = [];

    constructor(private message: NzMessageService,
                private confirmationService: ConfirmationService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        const { initialValue, submitLoading } = changes;
        if (submitLoading && !this.submitLoading) {
            this.isEditing = false;
        }
        if (initialValue) {
            this.initData();
        }
    }

    initData(): void {
        const data = this.initialValue;
        const isArray = Array.isArray(data);
        if (this.isRestrained) {
            this.currentValue = isArray ? (data.length > 0 ? data[0] : []) : data;
        } else {
            this.currentValue = isArray ? (data || []) : (data ? [data] : []);
        }
    }

    startEditing(): void {
        this.initData();
        this.lastValue = this.currentValue;
        this.isEditing = true;
        setTimeout(() => {
            this.selectComponent?.focus();
            this.openMenu = true;
        }, 200);
    }

    changeValue(): void {
        if (this.currentValue === this.lastValue) {
            this.isEditing = false;
            this.openMenu = false;
            return;
        }
        this.confirmationService.confirmUpdateTask(this.inactiveUsers, () => {
            setTimeout(() => {
                if (this.currentValue !== this.lastValue) {
                    this.valueChange.emit(this.currentValue);
                }
            }, 200);
        }, () => { this.currentValue = this.lastValue; })
    }

    changeSelect(arr: string[]): void {
        if (this.required && this.isEmpty) {
            this.message.error('This field is required');
            return;
        }
    }

    get isEmpty(): boolean {
        const isEmpty = (this.isRestrained && !this.currentValue) || (!this.isRestrained && this.currentValue.length === 0);
        return isEmpty;
    }

    openChange(visible: boolean): void {
        if (this.required && this.isEmpty) {
            this.currentValue = this.lastValue;
        }
        this.changeValue();
        if (!visible && this.isEditing) {
            this.isEditing = false;
        }
    }

    closeDropdown(): void {
        this.openMenu = false;
        this.selectComponent?.setOpenState(false);
    }
}
